module.exports = __webpack_public_path__ + "img/dr_6.695cf027.png";